import React from 'react'
import { MainBgImage } from '../../common'
import styled from 'styled-components'
import { scroller } from 'react-scroll'
import Svg from '../../common/Svg'
import { arrowDown } from '../../common/Svg/elements'
import { Alert } from 'reactstrap'
import { TextLink } from '../../common/Links'
import { H1 } from '../../GlobalStyles'

export const BackgroundImageWrapper = styled.div`
  position: absolute;
  top: 0%;
  left: 50%;
  transform: translateX(-50%);
  min-height: 720px;
  min-width: 1440px;
  z-index: -1;
  height: 100%;
  .gatsby-image-wrapper {
    height: 100%;
  }
`

export const VideoWrapper = styled.div`
  position: relative;
  display: block;
  width: 100%;
  padding: 0;
  overflow: hidden;
  &:before {
    display: block;
    content: '';
    padding-top: 56.25%;
  }
  &:after {
    content: '';
    position: absolute;
    left: 0px;
    top: 0px;
    width: 100%;
    height: 100%;
    background: rgba(15, 16, 19, 0.33);
    z-index: 100;
  }
  iframe {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0;
  }
`
const AlertMessage = styled(Alert)`
  width: 100%;
  text-align: center;
  position: absolute !important;
  top: 0px;
`

export const CircleButton = styled.div`
  display: block;
  margin: 0 auto;
  cursor: pointer;
  padding: 10px 10px;
  font-size: 12px;
  transition: all 0.5s;
  text-transform: uppercase;
  box-shadow: none;
  background-color: ${p => p.color || p.theme.colors.gold};
  border: 1px solid ${p => p.color || p.theme.colors.gold};
  color: #f8f1e2;
  transition: all 0.5s;
  font-weight: 700;
  text-transform: uppercase;
  width: 48px;
  height: 48px;
  border-radius: 24px;
  text-align: center;
  line-height: 1.8;
  margin-bottom: 200px;
  &:hover {
    background-color: ${p => p.color || p.theme.colors.darkGold};
    border: 1px solid ${p => p.color || p.theme.colors.darkGold};
    outline: none;
    text-decoration: none;
  }
`

const Video = ({ src }) => (
  <iframe
    src={src}
    frameBorder='0'
    webkitallowfullscreen='true'
    mozallowfullscreen='true'
    allowFullScreen
    title='PGA Coach'
  />
)

export const HomeMainImage = () => {
  return (
    <MainBgImage height={840} position='flex-end'>
      <H1 marginBottom='52px'>The Future of Coaching</H1>
      <TextLink url='/Coaching_Best_Practices_FINAL2_3_20_20_3.pdf'>
        <AlertMessage color='danger'>
          Click here for a list of best practices for you to consider
          implementing while coaching in the current COVID-19 (Coronavirus)
          environment
        </AlertMessage>
      </TextLink>
      <BackgroundImageWrapper>
        <VideoWrapper>
          <Video src='https://player.vimeo.com/video/318557649?background=1&autoplay=1&loop=1&byline=0&title=0' />
        </VideoWrapper>
      </BackgroundImageWrapper>
      <CircleButton
        onClick={() =>
          scroller.scrollTo('adm', {
            duration: 800,
            delay: 0,
            smooth: 'easeInOutQuart'
          })
        }
        aria-label='adm'
      >
        <Svg d={arrowDown} />
      </CircleButton>
    </MainBgImage>
  )
}

export default HomeMainImage
